// 表情映射表
const emojiMap = {
  // 笑脸类
  '😀': '😀', '😁': '😁', '😂': '😂', '🤣': '🤣', '😃': '😃', '😄': '😄',
  '😅': '😅', '😆': '😆', '😉': '😉', '😊': '😊', '😋': '😋', '😎': '😎',
  '😍': '😍', '😘': '😘', '🥰': '🥰', '😗': '😗', '😙': '😙', '😚': '😚',
  '🙂': '🙂', '🤗': '🤗', '🤩': '🤩', '🤔': '🤔', '🤨': '🤨', '😐': '😐',
  '😑': '😑', '😶': '😶', '🙄': '🙄', '😏': '😏', '😣': '😣', '😥': '😥',
  '😮': '😮', '🤐': '🤐', '😯': '😯', '😪': '😪', '😫': '😫', '😴': '😴',
  '😌': '😌', '😛': '😛', '😜': '😜', '😝': '😝',
  
  // 手势类
  '👍': '👍', '👎': '👎', '👌': '👌', '✌️': '✌️', '🤞': '🤞', '🤟': '🤟',
  '🤘': '🤘', '🤙': '🤙', '👈': '👈', '👉': '👉', '👆': '👆', '🖕': '🖕',
  '👇': '👇', '☝️': '☝️', '👋': '👋', '🤚': '🤚', '🖐️': '🖐️', '✋': '✋',
  '🖖': '🖖', '👏': '👏', '🙌': '🙌', '🤲': '🤲', '🤝': '🤝', '🙏': '🙏',
  '✍️': '✍️', '💪': '💪', '🦵': '🦵', '🦶': '🦶', '👂': '👂', '🦻': '🦻',
  
  // 动物类
  '🐶': '🐶', '🐱': '🐱', '🐭': '🐭', '🐹': '🐹', '🐰': '🐰', '🦊': '🦊',
  '🐻': '🐻', '🐼': '🐼', '🐨': '🐨', '🐯': '🐯', '🦁': '🦁', '🐮': '🐮',
  '🐷': '🐷', '🐽': '🐽', '🐸': '🐸', '🐵': '🐵', '🙈': '🙈', '🙉': '🙉',
  '🙊': '🙊', '🐒': '🐒', '🐔': '🐔', '🐧': '🐧', '🐦': '🐦', '🐤': '🐤',
  '🐣': '🐣', '🐥': '🐥', '🦆': '🦆', '🦢': '🦢', '🦅': '🦅', '🦉': '🦉',
  
  // 食物类
  '🍎': '🍎', '🍊': '🍊', '🍋': '🍋', '🍌': '🍌', '🍉': '🍉', '🍇': '🍇',
  '🍓': '🍓', '🫐': '🫐', '🍈': '🍈', '🍒': '🍒', '🍑': '🍑', '🥭': '🥭',
  '🍍': '🍍', '🥥': '🥥', '🥝': '🥝', '🍅': '🍅', '🍆': '🍆', '🥑': '🥑',
  '🥦': '🥦', '🥒': '🥒', '🥬': '🥬', '🌶️': '🌶️', '🫑': '🫑', '🌽': '🌽',
  '🥕': '🥕', '🫒': '🫒', '🧄': '🧄', '🧅': '🧅', '🥔': '🥔', '🍠': '🍠',
  
  // 活动类
  '⚽': '⚽', '🏀': '🏀', '🏈': '🏈', '⚾': '⚾', '🥎': '🥎', '🎾': '🎾',
  '🏐': '🏐', '🏉': '🏉', '🥏': '🥏', '🎱': '🎱', '🪀': '🪀', '🏓': '🏓',
  '🏸': '🏸', '🏒': '🏒', '🏑': '🏑', '🥍': '🥍', '🏏': '🏏', '🪃': '🪃',
  '🥅': '🥅', '⛳': '⛳', '🪁': '🪁', '🏹': '🏹', '🎣': '🎣', '🤿': '🤿',
  '🥊': '🥊', '🥋': '🥋', '🎽': '🎽', '🛹': '🛹', '🛷': '🛷', '⛸️': '⛸️',
  
  // 符号类
  '❤️': '❤️', '🧡': '🧡', '💛': '💛', '💚': '💚', '💙': '💙', '💜': '💜',
  '🖤': '🖤', '🤍': '🤍', '🤎': '🤎', '💔': '💔', '❣️': '❣️', '💕': '💕',
  '💞': '💞', '💓': '💓', '💗': '💗', '💖': '💖', '💘': '💘', '💝': '💝',
  '💟': '💟', '☮️': '☮️', '✝️': '✝️', '☪️': '☪️', '🕉️': '🕉️', '☸️': '☸️',
  '✡️': '✡️', '🔯': '🔯', '🕎': '🕎', '☯️': '☯️', '☦️': '☦️', '🛐': '🛐'
}

// 表情正则表达式
const emojiRegex = new RegExp(
  Object.keys(emojiMap).map(emoji => 
    emoji.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  ).join('|'), 
  'g'
)

/**
 * 将文本中的表情转换为HTML
 * @param {string} text - 包含表情的文本
 * @returns {string} - 转换后的HTML字符串
 */
export function parseEmojiToHtml(text) {
  if (!text) return text
  
  return text.replace(emojiRegex, (match) => {
    return `<span class="emoji-text" title="${getEmojiName(match)}">${match}</span>`
  })
}

/**
 * 检查文本是否包含表情
 * @param {string} text - 要检查的文本
 * @returns {boolean} - 是否包含表情
 */
export function hasEmoji(text) {
  if (!text) return false
  return emojiRegex.test(text)
}

/**
 * 获取表情名称
 * @param {string} emoji - 表情符号
 * @returns {string} - 表情名称
 */
export function getEmojiName(emoji) {
  const emojiNames = {
    '😀': '大笑',
    '😁': '露齿笑',
    '😂': '笑哭',
    '🤣': '满地打滚',
    '😃': '开心',
    '😄': '高兴',
    '😅': '苦笑',
    '😆': '眯眼笑',
    '😉': '眨眼',
    '😊': '微笑',
    '😋': '舔嘴',
    '😎': '酷',
    '😍': '花痴',
    '😘': '飞吻',
    '🥰': '爱心眼',
    '👍': '赞',
    '👎': '踩',
    '👌': 'OK',
    '✌️': '胜利',
    '🤞': '祈祷',
    '👏': '鼓掌',
    '🙏': '祈祷',
    '💪': '肌肉',
    '❤️': '红心',
    '💔': '心碎',
    '💕': '两心',
    '💖': '闪心',
    '💗': '爱心',
    '💘': '丘比特',
    '🐶': '小狗',
    '🐱': '小猫',
    '🐭': '小鼠',
    '🐹': '仓鼠',
    '🐰': '兔子',
    '🦊': '狐狸',
    '🐻': '熊',
    '🐼': '熊猫',
    '🐨': '考拉',
    '🐯': '老虎',
    '🦁': '狮子',
    '🐮': '牛',
    '🐷': '猪',
    '🐸': '青蛙',
    '🐵': '猴子',
    '🍎': '苹果',
    '🍊': '橙子',
    '🍋': '柠檬',
    '🍌': '香蕉',
    '🍉': '西瓜',
    '🍇': '葡萄',
    '🍓': '草莓',
    '⚽': '足球',
    '🏀': '篮球',
    '🏈': '橄榄球',
    '⚾': '棒球',
    '🎾': '网球'
  }
  return emojiNames[emoji] || emoji
}

/**
 * 统计文本中的表情数量
 * @param {string} text - 要统计的文本
 * @returns {number} - 表情数量
 */
export function countEmojis(text) {
  if (!text) return 0
  const matches = text.match(emojiRegex)
  return matches ? matches.length : 0
}

/**
 * 移除文本中的表情
 * @param {string} text - 包含表情的文本
 * @returns {string} - 移除表情后的文本
 */
export function removeEmojis(text) {
  if (!text) return text
  return text.replace(emojiRegex, '').replace(/\s+/g, ' ').trim()
}

/**
 * 插入表情到文本的指定位置
 * @param {string} text - 原文本
 * @param {string} emoji - 要插入的表情
 * @param {number} position - 插入位置
 * @returns {string} - 插入表情后的文本
 */
export function insertEmojiAtPosition(text, emoji, position) {
  if (!text) return emoji
  return text.slice(0, position) + emoji + text.slice(position)
}

export default {
  parseEmojiToHtml,
  hasEmoji,
  getEmojiName,
  countEmojis,
  removeEmojis,
  insertEmojiAtPosition
} 